<template lang="pug">
.formgroup-label(v-if="hasLabel")
  slot(name="default")
</template>

<script lang="ts" setup>

import {computed, useSlots} from "vue";

const props = defineProps({
  required: {
    type: Boolean,
    default: false
  },
  label: {
    type: [String, null],
    default: null
  },
})

const slots = useSlots()

const hasLabel = computed(() => {
  return !!props.label || !!slots.default;
})
</script>

<style scoped lang="less">
.formgroup-label {
  display: flex;
  flex-direction: column;
  min-height: 4.8rem;
  justify-items: center;
  justify-content: center;
  padding-top: 1.3rem;
  padding-bottom: 1.3rem;
}
</style>
